var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPolaroidDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: "auto",
  viewBox: "0 0 103 139",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.36.006h102v139.826H.36z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EDF4F3",
  d: "M6.395 5.835h90v102h-90z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.735 44.076a4.982 4.982 0 0 1 4.982-4.981h7.056c.948 0 1.875-.27 2.675-.779l4.296-2.734a4.981 4.981 0 0 1 2.675-.779h10.587c.948 0 1.875.27 2.675.779l4.296 2.734c.8.509 1.727.779 2.675.779h7.056a4.982 4.982 0 0 1 4.982 4.981v25.905a4.982 4.982 0 0 1-4.982 4.981H29.717a4.982 4.982 0 0 1-4.982-4.981V44.076Z",
  fill: "#405B73",
  fillOpacity: 0.85
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M51.865 43.387c-7.682 0-13.948 6.25-13.948 13.912 0 7.663 6.266 13.985 13.948 13.985 7.683 0 13.949-6.322 13.949-13.985 0-7.662-6.266-13.912-13.949-13.912Z",
  fill: "#F4CC54",
  fillOpacity: 0.85
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M51.866 47.678c-5.322 0-9.657 4.32-9.657 9.621 0 5.303 4.335 9.693 9.657 9.693 5.321 0 9.656-4.39 9.656-9.693 0-5.302-4.335-9.62-9.656-9.62Z",
  fill: "#F3F5F9",
  fillOpacity: 0.85
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.522 45.013c0-.66.535-1.194 1.195-1.194h4.779a1.194 1.194 0 1 1 0 2.39h-4.78c-.66 0-1.194-.536-1.194-1.196Z",
  fill: "#F4CC54",
  fillOpacity: 0.85
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M71.056 39.157h-4.78a1.194 1.194 0 1 1 0-2.39h4.78a1.195 1.195 0 1 1 0 2.39Z",
  fill: "#DDBE5B"
})));
export default SvgPolaroidDefault;